import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import MenuItem from "@mui/material/MenuItem";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import Select from "@mui/material/Select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";

const ChangeAddressForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState(false);
  const [isRestricted, setIsRestricted] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isInterested, setIsInterested] = useState(false);

  const [isSubmitable, setIsSubmitable] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [chairmanSignature, setChairmanSignature] = useState("");
  const [mom, setMom] = useState("");
  const [secretarySignature, setSecretarySignature] = useState("");

  const { customerId, bookingId } = useParams();

  const user = useSelector((state) => state?.UserReducer?.user);
  const [assocName, setAssocNameLabel] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);
  const [isReportsent, setIsReportSent] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [reportId, setReportId] = useState("");

  const [isAddDeviceModelOpen, setIsAddDeviceModelOpen] = useState(false);
  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);
  const [openCreateBookingModel, setOpenCreateBookingModel] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!previewOpenModel) setIsReportSent(false);
  }, [previewOpenModel]);

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);

  // -------------  Initial Data -------------
  // const fetchFunction = async () =>
  //   await axios.get(
  //     `${Config.nodeApiUrl}/getSenderIdContactGroups/sms`,
  //     Config.AxiosConfig
  //   );

  // const {
  //   data,
  //   error,
  //   isLoading: InitialLoading,
  // } = useQuery(`getSenderIdContactGroups`, fetchFunction);

  // -------------   Run Campaign  -------------
  const runCampaignFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/changeaddress`, values, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onRunCampaignSuccess = (res) => {
    //toast.success(res?.data?.msg || "Success");
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
    //navigate("/my-applications");
  };

  const onRunCampaignError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: runCampaignLoading, mutate: runCampaignMutate } =
    useMutation(runCampaignFunction, {
      onSuccess: onRunCampaignSuccess,
      onError: onRunCampaignError,
    });

  const InitialValue = {
    assocName: "",
    establishmentDate: "",
    oldAddress: "",
    newAddress: "",
    dated: "",
  };

  const SubmitHandler = (values) => {
    if (!values.appId) {
      return toast.error("Please select a Association name");
    } else if (!values.establishmentDate) {
      return toast.error("Please enter the Establishment Date");
    } else if (!values.oldAddress) {
      return toast.error("Please enter a Old Address");
    } else if (!values.newAddress) {
      return toast.error("Please enter the New Address");
    } else if (!values.dated) {
      return toast.error("Please enter the Date");
    } else if (!mom) {
      return toast.error("Please upload Minutes of Meeting Document");
    } else if (!chairmanSignature) {
      return toast.error("Please upload Chairman National Id");
    } else if (!secretarySignature) {
      return toast.error("Please upload Secretary National Id");
    }

    const body = new FormData();
    body.append("appId", values.appId);
    body.append("assocName", assocName);
    body.append("establishmentDate", values.establishmentDate);
    body.append("oldAddress", values.oldAddress);
    body.append("newAddress", values.newAddress);
    body.append("dated", values.dated);
    body.append("email", values.email);
    body.append("mom", mom);
    body.append("chairmanSign", chairmanSignature);
    body.append("secretarySign", secretarySignature);

    runCampaignMutate(body);
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t("Notice_Change")}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t("Notice_hereby")}</BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                    <>
                      <InputGroup>
                        <Label htmlFor="name">{t("a_name")}</Label>
                        <FieldWrapper $select={true}>
                          <Field
                            required
                            name="name"
                            id="name"
                            autoComplete="off"
                          >
                            {(props) => (
                              <Select
                                {...props.field}
                                className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                onChange={(e) => {
                                  const selectedItem = user.associations.find(
                                    (item) => item.id == e.target.value
                                  );
                                  // console.log(selectedItem.assocName);
                                  setAssocNameLabel(selectedItem.assocName);
                                  // SetDynamicAssociation(e.target.value);
                                  props.form.setFieldValue(
                                    "appId",
                                    e.target.value
                                  );
                                }}
                              >
                                {user.associations &&
                                  user.associations.map((item) => (
                                    <MenuItem value={item.id}>
                                      {item.assocName}
                                    </MenuItem>
                                  ))}
                              </Select>
                            )}
                          </Field>
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="establishmentDate">
                          {t("Establishment_Date")}
                        </Label>
                        <FieldWrapper>
                          <Field
                            name="establishmentDate"
                            id="establishmentDate"
                            autoComplete="off"
                            type="date"
                          />
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="oldAddress">{t("Old_Postal")}</Label>
                        <FieldWrapper>
                          <Field
                            name="oldAddress"
                            // as="textarea"
                            id="oldAddress"
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="newAddress">{t("New_Postal")}</Label>
                        <FieldWrapper>
                          <Field
                            name="newAddress"
                            id="newAddress"
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="dated">{t("Dated")}</Label>
                        <FieldWrapper>
                          <Field
                            name="dated"
                            id="dated"
                            autoComplete="off"
                            type="date"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="chairmanSignature">
                          Please upload chairman national id
                        </Label>
                        <DropZone setUploadFile={setChairmanSignature} />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="secretarySignature">
                          Please upload secretary national id
                        </Label>
                        <DropZone setUploadFile={setSecretarySignature} />
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="mom">{t("mom")}</Label>
                        <DropZone setUploadFile={setMom} />
                      </InputGroup>
                      {/* <InputGroup>
                          <Label htmlFor="chairmanSign">
                           {t('Chairman')}
                          </Label>
                          <DropZone setUploadFile={setChairmanSignature} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="secretarySsign">
                            {t('Secretary')}
                          </Label>
                          <DropZone setUploadFile={setSecretarySignature} />
                        </InputGroup> */}
                    </>
                  </FormContainer>
                  <div className="mt-14">
                    <SubmitBtn type="submit" disabled={runCampaignLoading}>
                      {runCampaignLoading && (
                        <Loading
                          color="white"
                          width={20}
                          height={20}
                          noPadding={true}
                        />
                      )}
                      {!runCampaignLoading && t("Send")}
                    </SubmitBtn>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-rose-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default ChangeAddressForm;
